import { MenuItem } from "./menu.types";

export const menuItems3: MenuItem[] = [
  {
    id: 11,
    label: "Vehicles",
    icon: "las la-car",
    permissionId: 6,
    subItems: [
      { id: 12, label: "List vehicles", icon: "las la-minus", to: "/Vehicles", permissionId: 6 },
      { id: 13, label: "Vehicle group", icon: "las la-minus", to: "/groupevehicles", permissionId: 6 },
    ],
  },
  {
    id: 14,
    label: "Drivers",
    icon: "las la-user-nurse",
    permissionId: 11,
    subItems: [
      { id: 15, label: "list_drivers", icon: "las la-minus", to: "/Drivers", permissionId: 11 },
      { id: 16, label: "driver_group", icon: "las la-minus", to: "/group-driver", permissionId: 11 },
    ],
  },
  { id: 17, label: "iButton Fleets", icon: "las la-tags", to: "/Ibutton", permissionId: 13 },
  { id: 18, label: "Points of Interest", icon: "las la-map-pin", to: "/pois", permissionId: 16 },
  { id: 19, label: "SIM cards", icon: "las la-sim-card", to: "/cartes-sim", permissionId: 7 },

  {
    id: 20,
    label: "GPS devices",
    icon: "las la-compass",
    permissionId: 14,
    subItems: [
      { id: 21, label: "List devices", icon: "las la-minus", to: "/Devices", permissionId: 14 },
      { id: 22, label: "Devices Group", icon: "las la-minus", to: "/groupe-device", permissionId: 14 },
    ],
  },

  {
    id: 23,
    label: "Alarms",
    icon: "las la-stopwatch",
    permissionId: 18,
    subItems: [
      { id: 24, label: "Alarm list", icon: "las la-minus", to: "/Alarms", permissionId: 18 },
      { id: 25, label: "Group Alarms", icon: "las la-minus", to: "/group-alarms", permissionId: 18 },
    ],
  },

  { id: 26, label: "Geofence checker", icon: "las la-map-marked", to: "/geofence-checker", permissionId: 49 },
  { id: 27, label: "Notifications", icon: "las la-bell", to: "/notifications", permissionId: 32 },

  {
    id: 28,
    label: "User Activity",
    icon: "las la-user-clock",
    permissionId: 20,
    subItems: [
      { id: 29, label: "History", icon: "las la-minus", to: "/history-user", permissionId: 20 },
      { id: 30, label: "connection_log", icon: "las la-minus", to: "/Connection", permissionId: 20 },
    ],
  },

  { id: 31, label: "Users", icon: "las la-user", to: "/Users", permissionId: 25 },

  { id: 32, label: "Divider", icon: "", permissionId: 0, divider: true },
];
